var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetable',{ref:"vuetable",attrs:{"api-url":"https://vuetable.ratiw.net/api/users","fields":[
    { name: 'name', title: 'Full Name', sortField: 'name' },
    ,
    'nickname',
    'email',
    'gender' ],"per-page":10}})}
var staticRenderFns = []

export { render, staticRenderFns }